import { ActionReducerMap } from '@ngrx/store';

import * as fromData from './data.reducer';
import * as fromStatus from '../reducers/status.reducer';
import * as fromBasket from '../reducers/basket.reducer';
import * as fromModal from '../reducers/modal.reducer';
import { UpgradeState } from '../../interfaces/store.interface';

export const reducers: ActionReducerMap<UpgradeState> = {
  data: fromData.reducer,
  status: fromStatus.reducer,
  basket: fromBasket.reducer,
  modal: fromModal.reducer,
};
